import utils from '@/utils';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getUserConnHistory: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		queryStr = utils.objectToQueryString({
			searchMonth: searchParams.searchMonth,
			searchUserId: searchParams.searchUserId,
			searchUserNm: searchParams.searchUserNm,
			currentPage,
			pageUnit
		});
		// console.log('queryStr : ',queryStr);
		let url = `${BASE_URL}/summary/v1/users` + queryStr;
		// console.log('url :' + url);
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
